export default "__VITE_ASSET__da2ec0a9__"